<template>
  <app-page title="App Analytics" icon="mobile-screen-button" class="analytics-app">
    <template #header>
      <divisions-dropdown />
    </template>
    <template #custom-content>
      <b-col>
        <analytics-nav />
        <snapshot-metrics />
        <track-metrics />

        <!-- Build (Workplace Savings) -->
        <build-metrics v-if="isBuildEnabled" />
        <locked-metric-panel v-else-if="portalUpdatesJan2026Enabled" product-key="build" />

        <stream-metrics />

        <!-- Budget -->
        <budget-metrics v-if="isBudgetEnabled && portalUpdatesJan2026Enabled" />
        <locked-metric-panel v-else-if="portalUpdatesJan2026Enabled" product-key="budget" />

        <!-- Rewards -->
        <rewards-metrics v-if="isRewardsEnabled && portalUpdatesJan2026Enabled" />
        <locked-metric-panel v-else-if="portalUpdatesJan2026Enabled" product-key="rewards" />

        <!-- SDL -->
        <sdl-metrics v-if="isSdlEnabled" />
        <locked-metric-panel v-else-if="portalUpdatesJan2026Enabled" product-key="sdl" />

        <!-- Coach -->
        <coach-metrics v-if="isCoachEnabled && portalUpdatesJan2026Enabled" />
        <locked-metric-panel v-else-if="portalUpdatesJan2026Enabled" product-key="coach" />

        <coach-metrics-stub v-if="tescoPortalStubsEnabled" />
      </b-col>
    </template>
  </app-page>
</template>

<script setup>
import AppPage from '@/components/AppPage.vue';
import BudgetMetrics from '@/pages/analyticsApp/components/BudgetMetrics.vue';
import BuildMetrics from '@/pages/analyticsApp/components/BuildMetrics.vue';
import CoachMetrics from '@/pages/analyticsApp/components/CoachMetrics.vue';
import CoachMetricsStub from '@/pages/analyticsApp/components/CoachMetricsStub.vue';
import LockedMetricPanel from '@/pages/analyticsApp/components/LockedMetricPanel.vue';
import RewardsMetrics from '@/pages/analyticsApp/components/RewardsMetrics.vue';
import SnapshotMetrics from '@/pages/analyticsApp/components/SnapshotMetrics.vue';
import StreamMetrics from '@/pages/analyticsApp/components/StreamMetrics.vue';
import TrackMetrics from '@/pages/analyticsApp/components/TrackMetrics.vue';
import AnalyticsNav from '@/pages/analyticsHomepage/components/AnalyticsNav.vue';
import DivisionsDropdown from '@/pages/analyticsHomepage/components/DivisionsDropdown.vue';
import SdlMetrics from '@/pages/analyticsApp/components/SdlMetrics.vue';
import useFeatureFlags from '@/composables/useFeatureFlags';
import useProductAvailability from '@/composables/useProductAvailability';

const { portalUpdatesJan2026Enabled, tescoPortalStubsEnabled } = useFeatureFlags();
const { isCoachEnabled, isBudgetEnabled, isRewardsEnabled, isSdlEnabled, isBuildEnabled } = useProductAvailability();
</script>
